import React from 'react'

import './../../assets/icons/icons.svg'

export default ({className = 'icon', icon}) => (
  <svg className={className} aria-hidden="true" role="img">
    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#icons_icon-${icon}`} />
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Global/Icon.js